export const SpecialMentionDialogId = {
	allParticipants: 'all',
};
